import { render, staticRenderFns } from "./SendButton.vue?vue&type=template&id=7b9ad4be&scoped=true"
import script from "./SendButton.vue?vue&type=script&lang=ts"
export * from "./SendButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ad4be",
  null
  
)

export default component.exports